export const searchFetchContactable = (url, input) => fetch(url, {
  method: "POST",
  body: new URLSearchParams({
    searchTerm: input
  })
}).then((response) => response.json());
